import authentication from '../middleware/authentication'

const ListPhoneAccount = () => import(/* webpackChunkName: "static/js/chunks/ListPhoneAccount" */'../../views/phoneAccount/ListPhoneAccount')

const phoneAccountRoutes = [
  {
    path: '/phone-account',
    component: ListPhoneAccount,
    name: 'ListPhoneAccount',
    hidden: true,
    meta: {
      middleware: authentication,
      layout: 'main'
    }
  }
]

export default phoneAccountRoutes
